"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/styles");
var _material = require("@mui/material");
var _InsertComment = _interopRequireDefault(require("@mui/icons-material/InsertComment"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CustomSelect = _interopRequireDefault(require("./CustomSelect"));
var _lodash = require("lodash");
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _AddComment = _interopRequireDefault(require("../../../dist/components/dialogs/AddComment"));
var _FormGroup = _interopRequireDefault(require("@mui/material/FormGroup"));
var _Grid = _interopRequireWildcard(require("@mui/material/Grid"));
var _surveyUtils = require("../../utilities/surveyUtils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    centerText: {
      textAlign: 'center'
    }
  };
};
var CustomDiamFreeTextQuestion = /*#__PURE__*/function (_Component) {
  function CustomDiamFreeTextQuestion(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomDiamFreeTextQuestion);
    _this = _callSuper(this, CustomDiamFreeTextQuestion, [props]);
    ['handleAddComment', 'convertToValue'].map(function (item) {
      return _this[item] = _this[item].bind(_this);
    });
    var serviceList = props.serviceList,
      value = props.value;
    var answers = value ? value.map(function (v) {
      return JSON.parse(v);
    }) : [];
    var textValues = serviceList.map(function (s) {
      var answer = answers.find(function (a) {
        return a.serviceID === Number(s.value);
      });
      var item = {
        serviceID: Number(s.value),
        textValue: '',
        textValueComment: ''
      };
      if (answer) {
        item.textValue = answer.textValue;
        item.textValueComment = answer.textValueComment;
      }
      return item;
    });
    _this.state = {
      showCommentDialog: false,
      clickedServiceID: '',
      clickedField: '',
      commentVal: '',
      textValues: textValues
    };
    return _this;
  }
  (0, _inherits2["default"])(CustomDiamFreeTextQuestion, _Component);
  return (0, _createClass2["default"])(CustomDiamFreeTextQuestion, [{
    key: "convertToValue",
    value: function convertToValue(textValues) {
      var values = textValues.map(function (v) {
        return JSON.stringify(v);
      });
      return values;
    }
  }, {
    key: "updateText",
    value: function updateText(serviceID, field, value) {
      var _this2 = this;
      var textValues = [].concat(this.state.textValues);
      var textValue = textValues.find(function (r) {
        return r.serviceID === serviceID;
      });
      textValue[field] = value;
      this.setState({
        textValues: textValues
      }, function () {
        _this2.props.onChange(_this2.convertToValue(textValues));
      });
    }
  }, {
    key: "handleAddComment",
    value: function handleAddComment(value, field, serviceID) {
      var _this3 = this;
      var textValues = [].concat(this.state.textValues);
      var textValue = textValues.find(function (r) {
        return r.serviceID === serviceID;
      });
      textValue[field] = value;
      this.setState({
        textValues: textValues
      }, function () {
        _this3.props.onChange(_this3.convertToValue(textValues));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        serviceList = _this$props.serviceList,
        parentQuestionNumbers = _this$props.parentQuestionNumbers,
        questionNumber = _this$props.questionNumber,
        validationRule = _this$props.validationRule;
      var _this$state = this.state,
        showCommentDialog = _this$state.showCommentDialog,
        textValues = _this$state.textValues;
      var parentQuestionNumberLabel = parentQuestionNumbers !== null ? "".concat(parentQuestionNumbers.join('.'), ".") : '';
      var questionNumberLabel = "".concat(parentQuestionNumberLabel + (0, _surveyUtils.numberToLetter)(questionNumber), ".");
      var isNumeric = validationRule && validationRule.validatorFunctionName === 'isFloat';
      return [/*#__PURE__*/_react["default"].createElement(_material.Table, {
        key: "diamFreeText".concat(questionNumber)
      }, /*#__PURE__*/_react["default"].createElement(_material.TableHead, null, /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
        style: {
          backgroundColor: '#fafafa'
        }
      }, serviceList.map(function (d) {
        return /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.centerText,
          padding: 'normal',
          key: d.value
        }, d.label);
      }), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null))), /*#__PURE__*/_react["default"].createElement(_material.TableBody, null, /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
        key: "name"
      }, serviceList.map(function (d) {
        var serviceID = Number(d.value);
        var textValue = textValues.find(function (r) {
          return r.serviceID === serviceID;
        });
        return /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.centerText,
          padding: 'normal',
          key: "service-".concat(serviceID)
        }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
          label: "",
          name: "name",
          type: isNumeric ? 'number' : 'text',
          onBlur: function onBlur(e) {
            _this4.updateText(serviceID, 'textValue', e.target.value);
          },
          defaultValue: textValue.textValue
        }), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          title: "Add Comment",
          "aria-label": "add"
        }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
          disabled: false,
          "aria-label": "Add Comment",
          onClick: function onClick() {
            return _this4.setState({
              showCommentDialog: true,
              commentVal: textValue.textValueComment,
              clickedField: 'textValueComment',
              clickedServiceID: serviceID
            });
          }
        }, /*#__PURE__*/_react["default"].createElement(_InsertComment["default"], {
          color: textValue.textValueComment !== '' && textValue.textValueComment !== undefined ? 'primary' : 'inherit'
        }, textValue.textValueComment)))));
      }), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null)))), /*#__PURE__*/_react["default"].createElement(_AddComment["default"], {
        open: showCommentDialog,
        commentVal: this.state.commentVal,
        title: 'Add/Edit Comment',
        contentText: "(Limited to 100 characters)",
        onConfirm: function onConfirm(comment) {
          _this4.setState({
            showCommentDialog: false
          });
          _this4.handleAddComment(comment, _this4.state.clickedField, _this4.state.clickedServiceID);
        },
        onClose: function onClose() {
          return _this4.setState({
            showCommentDialog: false
          });
        },
        key: "diamComment-".concat(questionNumber)
      })];
    }
  }]);
}(_react.Component);
CustomDiamFreeTextQuestion.propTypes = {};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomDiamFreeTextQuestion);